import { create } from 'zustand';
// import { APIUtils } from '../../utils/apiutils';
// import httpClient from '../../services/http';
// import { StreamVideoClient } from '@stream-io/video-react-sdk';
// import { nanoid } from 'nanoid';

// async function createGetstreamClient({userId, name}) {
//     const apiKey = process.env.REACT_APP_GETSTREAM_API_KEY;

//     const user = {
//       id: `${userId}`,
//       name,
//       image: `https://getstream.io/random_svg/?id=${userId}&name=${name}`,
//     };

//     const { err, res } = await httpClient.post(APIUtils.getAPIEndpoint('user:getstream-token'), {userId: `${userId}`})
//     .then(res => ({ err: null, res: res.data }))
//     .catch(err => ({ err, res: null }));

//     console.log({err, res});
//     if (err) {
//         return { err, client: null };
//     }

//     const token = res.token;
//     const client = new StreamVideoClient({ apiKey, user, token });

//     return { err: null, client };
// }

// async function ringCall({mineId, userIds, client}) {
//     const members = userIds.map(id => ({ user_id: id }));

//     const callID = nanoid();
//     const call = client.call('default', callID);
//     try {
//         await call.getOrCreate({
//             ring: true,
//             data: {
//                 created_by_id: mineId,
//                 members
//             },
//         });
//     } catch (error) {
//         return { err: error, call: null };
//     }

//     return { err: null, call };
// }

export const useVideoCallStore = create((set, get) => ({
    client: null,
    call: null,
    setClient: (clientData) => set(state => ({...state, client: clientData})),
    setCall: (callData) => set(state => ({...state, call: callData})),
    endCall: async () => {
        const call = get().call;
        // console.log({call});
        if (call && call.isCreatedByMe) {
            await call.endCall().catch(() => console.error('Failed to end the call'));
        }
        // if (call) {
        //     if (call.isCreatedByMe) {
        //         await call.endCall();
        //     } else {
        //         await call.leave();
        //     }
        // }
        set(state => ({...state, call: null}));
    },
    // endCallByCaller: async () => {
    //     const call = get().call;
    //     if (call) {
    //         await call.endCall();
    //     }
    //     set(state => ({...state, call: null}));
    // },
    // endCallByParticipant: async () => {
    //     const call = get().call;
    //     if (call) {
    //         await call.leave();
    //     }
    //     set(state => ({...state, call: null}));
    // },
    // createGSClient: async ({userId, name}) => {
    //     const {err, client} = await createGetstreamClient({userId, name});
    //     if (!err) {
    //         set(state => ({ ...state, client }));
    //     }
    // },
    // startRining: async ({mineId, userIds}) => {
    //     const {err, call} = await ringCall({mineId, userIds, client: get().client});
    //     if (!err) {
    //         set(state => ({ ...state, call }));
    //     }
    // },
}));